const carouselScrollPositionsHelper = require('../../page/frontend/helpers/carousel_scroll_positions');

class CarouselScrollRememberance {
  constructor(storageKey) {
    this.storageKey = storageKey;
  }

  addEventListener() {
    document.addEventListener(
      'mousedown',
      this.createOnMouseDownHandler(this.storageKey)
    );
  }

  createOnMouseDownHandler(storageKey) {
    return function(event) {
      let element = event.target;

      while (element.matches && !element.matches('figure.cui-c-udc')) {
        element = element.parentNode;
      }

      if (element.matches) {
        window.sessionStorage.setItem(
          storageKey,
          JSON.stringify(
            carouselScrollPositionsHelper.getCarouselScrollPositions()
          )
        );
      }
    };
  }

  scrollCarouselToLastRememberedPosition() {
    const scrollPosition = JSON.parse(
      window.sessionStorage.getItem(this.storageKey)
    );

    if (scrollPosition) {
      carouselScrollPositionsHelper.restoreCarouselScrollPositions(
        scrollPosition
      );
    }
  }
}

module.exports = CarouselScrollRememberance;
